<template>
  <div>
    <div v-if="item" class="row">
      <div class="col-md-7 mb-4 text-center">

        <a v-if="previewImage" :href="previewImage.url" class="is-lightbox">
          <img :src="previewImage.url" class="img-fluid shop-item-image" :alt="previewImage.name">
        </a>
        <div class="flex padd30t">
          <div class="img-fluid shop-additional-item-image-wrapper"
            v-for="media in variantMedia.filter(x => (!previewImage || previewImage &&  x.id != previewImage.id))">
            <a :href="media.url" class="is-lightbox">
              <img :src="media.url" class="shop-additional-item-image" style="margin:12px;max-height: 60px"
                :alt="media.name">
            </a>
          </div>
        </div>
      </div>

      <div class="item-to-cart col-md-5 mb-4">

        <div class="p-4">
          <div class="mb-3">
            <h3>{{item.name}}</h3>

            <!-- Average rating -->
            <div v-if="eshopProductsReviewsSetting == 1" class="reviews-average">
              <template v-if="averageRating > 0">
                <span v-for="i in 5" :key="i" class="fa-stack" style="width:1em">
                  <i class="far fa-star fa-stack-1x"></i>
                  <i v-if="averageRating >= i" class="fas fa-star fa-stack-1x"></i>
                  <i v-else-if="averageRating == i - 0.5" class="fas fa-star-half fa-stack-1x"></i>
                </span>
                <h6 class="badge badge-secondary" style="margin: 2px 1px; font-size: x-small">{{ reviewsCount }} {{
                  __t_choice('webapp.reviews', reviewsCount) }}</h6>
              </template>
              <template v-else>
                <span v-for="i in 5" :key="i" class="fa-stack" style="width:1em">
                  <i class="far fa-star fa-stack-1x"></i>
                </span>
                <h6 class="badge badge-secondary" style="margin: 2px 1px; font-size: x-small">{{
                  __t('webapp.no_reviews') }}</h6>
              </template>
            </div>

            <span v-if="!hasVariants && item.sku" class="sku">SKU: {{item.sku}}</span>
            <span v-if="hasVariants && specifiedVariant && specifiedVariant.sku" class="sku"> SKU:
              {{specifiedVariant.sku}}</span>

            <span v-for="tag in item.tags">
              <a :href="`${shopUrl}?tags[]=${tag}`">
                <span class="badge mr-1">{{tag}}</span>
              </a>
            </span>
          </div>
          <div>
            <span v-if="specifiedVariant">
                <span v-if="parseFloat(discVariantPrice) !== parseFloat(specifiedVariant.price)">
                  <del>{{ adjustedDeletedPrice(specifiedVariant.price) }} {{ currency }}</del>
                </span>
                <span v-else-if="parseFloat(specifiedVariant.compare_at_price) > parseFloat(item.price)">
                  <del>{{ adjustedDeletedPrice(specifiedVariant.compare_at_price) }} {{ currency }}</del>
                </span>

                <span>{{ finalPriceOfItem() }} {{ currency }}</span>
            </span>
            <span v-else>
                <span v-if="hasRange === '1'">{{ __t('shop.product.from') }}</span>
                <span v-if="parseFloat(priceBefore) > parseFloat(priceAfter)">
                  <del>{{ adjustedDeletedPrice(priceBefore) }} {{ currency }}</del>
                </span>
                <span v-else-if="parseFloat(item.compareAtPrice) > parseFloat(item.price)">
                  <del>{{ adjustedDeletedPrice(item.compareAtPrice) }} {{ currency }}</del>
                </span>

                <span>{{ finalPriceOfItem() }} {{ currency }}</span>
            </span>
          </div>

            
            <!-- variants -->
            <div v-for="optionGroup in item.variantOptionGroups" :key="optionGroup.id">
              {{ optionGroup.name }}:
            
              <div class="options">
                <!-- Loop over unique options in each option group -->
                <div 
                  v-for="option in uniqueOptions(optionGroup)" 
                  :key="option.id" 
                  style="display: inline-block;"
                >
                  <a href="#" @click.prevent="handleOptionSelect(optionGroup, option)">
                    <div 
                      :class="{
                        selected: selectedVariant[optionGroup.id] === option.id,
                        unavailable: !isOptionAvailable(optionGroup, option)
                      }" 
                      class="option"
                      style="display: inline-block;"
                    >
                      <div v-if="option.color" :style="{ backgroundColor: option.color }" 
                        class="color-swatch"
                        :data-color-name="option.name"
                        ></div>
                      <!-- Show variant image for the color option group -->
                      <img 
                        v-else-if="optionGroup.type.toLowerCase() === 'color' && getVariantImage(optionGroup, option)" 
                        :src="getVariantImage(optionGroup, option).url" 
                        :alt="option.name" 
                        class="option-image"
                      />
                      <!-- Show text for other option groups -->
                      <span v-else class="option-name">
                        {{ option.name }}
                      </span>
                    </div>
                  </a>
                </div>
              </div>
            </div>            

            <!-- options/extras -->
           <item-options
              ref="itemOptions"
              :item="item"
              :discPrice="discVariantPrice"
              :variant="specifiedVariant"
              type="add"
              :quantity="quantity"
              :total-cost="totalCost"
              :bus="eventBus"
              @cost-changed="totalCost = $event"
            />

            <hr>

          <div v-if="hasVariants">
            <div v-if="variantSelectionMessage" class="alert" :class="variantSelectionAlertClass">
              {{variantSelectionMessage}}
            </div>
          </div>
          <div v-else>
            <div v-html="itemAvailabilityHtml"></div>
          </div>

          <br>
          <div class="flex justify-between">
            <quantity-control :quantity="quantity" @change="handleQuantityChange" />
            <div>
              {{ totalCostWithVat }} {{currency}}
            </div>     

          </div>

          <div style="padding-top:50px">
            <button @click.prevent="addToCart" :disabled="!canAddToCart"
              class="btn is-btn-primary shop-button shop-add-to-cart-button btn-block" type="submit">
              <i class="fas fa-shopping-cart"></i>
              {{__t('shop.product.add_to_cart')}}

            </button>
          </div>


        </div>

      </div>

      <add-to-cart-sidebar :currency="currency" :cost="totalCost" :item="item"
        :minimum-purchase-amount-enabled="minimumPurchaseAmountEnabled === '1'"
        :minimum-purchase-amount="parseFloat(minimumPurchaseAmount)" ref="addToCartSidebar" />

    </div>

  </div>
</template>
<script>

import select2 from '@/components/ui/select2';
import QuantityControl from './common/quantity-control';
import itemOptions from './item-options';
import addToCartSidebar from './add-to-cart-sidebar';
import SimpleLightbox from 'simplelightbox';
import 'simplelightbox/dist/simple-lightbox.min.css';

import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
    components: {select2,QuantityControl,itemOptions,addToCartSidebar},
    data: function(){
        return {
          lightbox: null,
          eventBus: new Vue(),
          previewImage: null,
          item: null,
          discPrices: null,
          currency: window.currency,
          quantity: 1,
          selectedVariant: {},
          specifiedVariant: null,
          defaultVariant: null,
          validVariants: [],
          originalVariantPrice: null,
          validSelectedVariant: false,
          variantSelectionAlertClass: '',
          variantSelectionMessage : '',
          totalCost: 0,
          vatPercentage: null,
          discVariantPrice: 0,
        }
    },
    props:{
      cartUrl: String,
      itemJson: String,
      discountPrices: String,
      shopUrl: String,
      priceAfter: String,
      priceBefore: String,
      hasRange: String,
      averageRating: String,
      reviewsCount: String,
      eshopProductsReviewsSetting: String,
      defaultVat: {
        type: Object,
        default: null // Allowing null as a default value
      },
      b2bEnabled : {
        type: String, 
        required: true
      },
      minimumPurchaseAmountEnabled: {
        type: String,
        required: true
      },
      minimumPurchaseAmount: {
        type: Number,
        required: true
      },
    },
    methods:{
      ...mapActions([
        'addItemToCart',
        'initCart',
        'fetchShopInfo',
        'removeFromCart'
      ]),
      initLightBox() {
      if (this.lightbox) this.lightbox.destroy();

      this.lightbox = new SimpleLightbox('a.is-lightbox', {
        closeText: '<i style="font-size:35px" class="icon ion-ios-close-empty"></i>',
        navText: ['<i class="icon ion-ios-arrow-left"></i>', '<i class="icon ion-ios-arrow-right"></i>'],
        doubleTapZoom: 2,
        maxZoom: 10,
        disableScroll: false
      });
      },
      handleQuantityChange(value){

        if(!this.hasVariants && this.item.stock < value){
          if(this.item.track_stock && !this.item.allow_backorders){
            return;
          }else{
            this.quantity = value;
            return;
          }
        }

        if(this.hasVariants && this.specifiedVariant == null)
          return;

        if(this.hasVariants && this.specifiedVariant.stock < value){
          return;
        }

        this.quantity = value;
      },
      addToCart(){
        var item = this.item;

        var itemOptionsData = this.$refs.itemOptions.get();
        var comments = itemOptionsData.comments;
        var quantity = itemOptionsData.quantity;
        var options  = itemOptionsData.options;
        var variant = this.specifiedVariant;

        this.addItemToCart({
          item,
          comments,
          quantity,
          options,
          variant
        }).then(added => {
          if(added){
            this.$refs.addToCartSidebar.setOptions(options)
            this.$refs.addToCartSidebar.setVariant(variant)
            this.$refs.addToCartSidebar.flash();
            // toastr.success(this.__t('shop.product.added_to_cart',{name: item.name}));
          }
        });


      },
      handleOptionSelect(optionGroup, option) {
        // Update the selected option for the specific option group
        this.$set(this.selectedVariant, optionGroup.id, option.id);
        // Find the matching variant based on selected options
        const matchingVariant = this.findMatchingVariant(option);
        if (matchingVariant) {
          this.specifiedVariant = matchingVariant;

          // Update the preview image based on the selected variant
          this.previewImage = this.getVariantImage(optionGroup, option) || this.item.media[0];
          this.$nextTick(() => { this.initLightBox(); });
        } else {
          console.warn('No matching variant found.');
        }
      },
      getVariantImage(optionGroup, option) {
        // Find the first variant that matches the selected option
        const variant = this.item.variants.find((variant) => {
        return variant.values.some(
            (value) => value.optionGroup.id === optionGroup.id && value.option.id === option.id
          );
        });

        // Return the media URL if the variant has associated media
        return variant && variant.media.length > 0 ? variant.media[0] : null;
      },
      findMatchingVariant(option) {
        // Iterate through the variants to find a match
        for (let variant of this.item.variants) {
          let match = false;
          // TODO probably could be a map / find instead of loob - break
          for (let value of variant.values) {
            if (option.id === value.option.id) {
              match = true;
              break;
            }
          }

          if (match) {
            return variant;
          }
        }

        return null;
      },
      uniqueOptions(optionGroup) {
        const seenOptions = new Set();
        return this.item.variants
          .map((variant) => {
            return variant.values.find(
              (value) => value.optionGroup.id === optionGroup.id
            ).option;
          })
          .filter((option) => {
            if (seenOptions.has(option.id)) return false;
            seenOptions.add(option.id);
            return true;
          });
      },
      isOptionAvailable(optionGroup, option) {
        return this.item.variants.some((variant) => {
          return variant.values.some(
            (value) => value.optionGroup.id === optionGroup.id && value.option.id === option.id
          );
        });
      },
      initUserSelectedVariants() {
        const selectedVariant = {};
        this.item.variantOptionGroups.forEach(group => {
          selectedVariant[group.id] = '';
        });
        this.selectedVariant = selectedVariant;
      },
      initValidVariants() {
        this.validVariants = this.item.variants.map(variant => {
          const validVariant = {};
          validVariant.id = variant.id;
          variant.values.forEach(value => {
            validVariant[value.optionGroup.id] = value.option.id;
          });
          return validVariant;
        });
      },
      initDefaultVariant() {
        this.defaultVariant = this.item.variants.find(variant => variant.is_default === 1);

        if (this.defaultVariant) {
          // Select default variant's options
          this.item.variantOptionGroups.forEach(optionGroup => {
            const option = this.defaultVariant.values.find(value => value.optionGroup.id === optionGroup.id)?.option;

            if (option) {
              this.handleOptionSelect(optionGroup, option);
            }
          });
        }
      },
      vatAmount() {
        const discountVariantPrice = parseFloat(this.specifiedVariant ? this.discVariantPrice : this.priceAfter);
        this.vatAmountValue = parseFloat(discountVariantPrice -  discountVariantPrice / (1 + this.vatPercentage / 100)).toFixed(2);
        return this.vatAmountValue;
      },
      finalPriceOfItem() {
        const discountVariantPrice = parseFloat(this.specifiedVariant ? this.discVariantPrice : this.priceAfter);

        if (this.b2bEnabled === 'true' && !this.item.include_vat) {
          return (discountVariantPrice / (1 + this.vatPercentage / 100)).toFixed(2);
        }

        return discountVariantPrice.toFixed(2);
      },
      adjustedDeletedPrice(originalPrice) {
        let adjustedPrice = parseFloat(originalPrice);

        if (this.b2bEnabled === 'true' && !this.item.include_vat) {
          adjustedPrice = adjustedPrice / (1 + this.vatPercentage / 100);
        }

        return adjustedPrice.toFixed(2);
      },
      fetchVatCategory() {
        const vatCategoryId = this.item.vat_category_id;
        const alias = window.company_alias;
        
        if (!vatCategoryId) {
          this.vatPercentage = null;
          if(this.defaultVat){
            this.vatPercentage = this.defaultVat.percentage;
          }
          return;
        }

        fetch(route('webapp.shop.vat_category',  {alias, vatCategory_id : vatCategoryId }))
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              this.vatPercentage = data.percentage;
            })
            .catch(error => {
              console.error('Error fetching VAT category percentage:', error);
            });
        },
      calculateDiscVariantPrice() {
        this.discVariantPrice = parseFloat(this.priceAfter).toFixed(2);
      },
      
    },   
    computed:{
        variantMedia(){
          if(!this.specifiedVariant) return this.item.media;
          return this.specifiedVariant.media;
        },
        ...mapGetters({cart: 'getCart'}),
        hasVariants(){
          return this.item.variants.length > 0;
        },
        itemAvailabilityHtml(){
          var message = '';
          var alertClass   = '';

          function htmlMessage(message,alertClass){
            return `<div class="alert ${alertClass}">${message}</div>`
          }

          // doesn't track stock or tracks and has stock
          if(!this.item.track_stock || (this.item.track_stock && this.item.stock > 0)){
            message = this.__t('shop.product.available');
            alertClass = 'alert-success';
            return htmlMessage(message,alertClass);
          }

          if(this.item.allow_backorders){
            message = this.__t('shop.product.available_for_backorder');
            alertClass = 'alert-warning';
            return htmlMessage(message,alertClass);
          }

            message = this.__t('shop.product.out_of_stock');
            alertClass = 'alert-danger';
            return htmlMessage(message,alertClass);


        },
        canAddToCart(){
          if(this.item.variants.length){
            return this.validSelectedVariant;
          }

          return true;
        },
        computeVatAmount() {
          const discVariantPrice = parseFloat(this.priceAfter);
          this.vatAmountValue = parseFloat( discVariantPrice * (this.vatPercentage / 100)).toFixed(2);
          return this.vatAmountValue ;
        },
        // priceWithVat() {
        //   const discVariantPrice = parseFloat(this.priceAfter);
        //   return parseFloat(discVariantPrice + this.vatAmount);
        // },

        totalCostWithVat() {
          const totalVat = parseFloat(this.quantity * this.vatAmount());
          if(this.b2bEnabled === 'true' && !this.item.include_vat) {
            this.totalCost = (parseFloat(this.totalCost) - totalVat).toFixed(2);
          }else if(this.b2bEnabled === 'false' && this.item.include_vat) {
            this.totalCost = (parseFloat(this.totalCost) + totalVat).toFixed(2);
          }else {
            this.totalCost = (parseFloat(this.totalCost)).toFixed(2);
          }

        return parseFloat(this.totalCost).toFixed(2);
        },
    },
    watch: {
      selectedVariant: {
        deep: true,
        handler(value, oldSelectedVariant) {
              var valid = false;
              var variantSelectionMessage = '';
              var specifiedVariant = null;
              var variantSelectionAlertClass = '';


            this.validVariants.forEach(validVariant => {
              if(this.$_.isEqual(value, this.$_.omit(validVariant,'id'))){
                var variant = this.item.variants.find(x => x.id == validVariant.id);
                specifiedVariant = variant;
                if(Object.keys(this.discPrices).length > 0){
                  for (var key in this.discPrices) {
                    if(key == specifiedVariant.id){
                      this.discVariantPrice = this.discPrices[key];
                    }
                  }
                }else{
                  this.discVariantPrice = specifiedVariant.price;
                }
               
                if(variant.media[0]){
                  this.previewImage = variant.media[0];
                }else{
                  this.previewImage = this.item.media[0];
                }

                if(!variant.track_stock) {
                  valid = true;
                  variantSelectionAlertClass = 'alert-success';
                  variantSelectionMessage = this.__t('shop.product.available');
                }else if(variant.stock >= this.quantity){
                  valid = true;
                  variantSelectionAlertClass = 'alert-success';
                  variantSelectionMessage = this.__t('shop.product.in_stock',{stock: variant.stock});
                }else{
                  if(variant.allow_backorders){
                      valid = true;
                      variantSelectionAlertClass = 'alert-warning';
                      variantSelectionMessage = this.__t('shop.product.available_for_backorder');
                  }else{
                      valid = false;
                      variantSelectionAlertClass = 'alert-danger';
                      variantSelectionMessage = this.__t('shop.product.out_of_stock');
                  }
                }
              }

              });

              this.specifiedVariant = specifiedVariant;
              this.validSelectedVariant = valid;
              this.variantSelectionMessage = variantSelectionMessage;
              this.variantSelectionAlertClass = variantSelectionAlertClass

          }
        }
      },
    mounted(){
      this.initLightBox();
      this.calculateDiscVariantPrice(); 
    },
    created(){
      this.initCart(window.company_alias);
      this.fetchShopInfo();

      this.item = JSON.parse(this.itemJson);
      this.discPrices = JSON.parse(this.discountPrices);

      this.previewImage = this.item.media[0];

      if(this.item.variants.length){

        // init user selected variants
        this.initUserSelectedVariants();
        // init valid variants
        this.initValidVariants();

      }
 
    this.fetchVatCategory();
    this.initDefaultVariant();
  }
}
</script>

<style scoped>
  .color-swatch{
    width:40px; 
    height:40px;
    margin-top: 10px;
  }

  .option-image{
    width:40px; 
    height:40px; 
    border-radius: 99px;
    margin: 5px; 
    border: 1px solid #ccc; 
    padding: 0px;
  }

  .option-name{
    border: 1px solid #ccc;
    padding: 5px;
  }

  .options{
    flex-wrap: wrap;
    display: flex;
    margin:5px;
    align-items: center;
  }
  .option{
    color: #444;
    display: block;
    margin: 5px;
  }

  .option.selected{
    border-color: green;
  }

  .option.unavailable{
    display: none;
  }

  .item-to-cart {
    position:sticky;
    top:20px;
  }
</style>